<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Manage Reporting Config</div>
    </div>

    <div class="table-container">
      <table [dataSource]="dataSource" mat-table aria-describedby="Report Config List">
        <ng-container matColumnDef="methodology">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div (click)="toggleSingleSort('methodology')" class="header-with-sort">
              <span>Methodology</span>
              <span [class]="sortBy['methodology']" id="sort-icon-container">
                <fc-sort-icon [column]="'methodology'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
          </th>
          <td *matCellDef="let row" class="methodology" mat-cell>
            {{ row.methodology }}
          </td>
        </ng-container>

        <ng-container matColumnDef="report">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div (click)="toggleSingleSort('report_type')" class="header-with-sort">
              <span>Report Type</span>
              <span [class]="sortBy['report_type']" id="sort-icon-container">
                <fc-sort-icon [column]="'report_type'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
          </th>
          <td *matCellDef="let row" mat-cell>{{ row.reportType }}</td>
        </ng-container>

        <ng-container matColumnDef="version">
          <th scope="col" *matHeaderCellDef mat-header-cell class="medium-column">
            <div (click)="toggleSingleSort('version')" class="header-with-sort">
              <span>Version</span>
              <span [class]="sortBy['version']" id="sort-icon-container">
                <fc-sort-icon [column]="'version'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>

            <mat-form-field>
              <mat-select
                (selectionChange)="doGetItemByBuyerId($event, 'report_version')"
                [(value)]="filterValues.report_version"
                class="select-filter">
                <mat-option value="Current">Current</mat-option>
                <mat-option value="All">Show All</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>{{ row.version }}</td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr (click)="clickRow($event, row)" *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>
  </div>
</div>
